import { Button, Spacing, Spinner, StatusLabel } from "@snapchat/snap-design-system";
import { useEffect, useRef } from "react";
import { css } from "@emotion/react";
import { FlexSection, Flexbox } from "../components/Flexbox";
import { useLoginKitDispatch, useLoginKitState } from "./LoginKitContext";

const buttonStyle = css`
    margin-left: ${Spacing.SM}px;
`;

const sectionStyle = css`
    margin-bottom: ${Spacing.SM}px;
`;

interface LoginKitPanelProps {
    onLogout?: () => void;
}

export function LoginKitPanel({ onLogout }: LoginKitPanelProps) {
    const { userName, initialAccessCheck } = useLoginKitState();
    const loginButtonRef = useRef<HTMLDivElement>(null);
    const { logout, mountButton } = useLoginKitDispatch();

    useEffect(() => {
        const loginButton = loginButtonRef.current;

        if (loginButton) {
            mountButton(loginButtonRef.current.id);
        }

        return undefined;
    }, [mountButton]);

    if (!initialAccessCheck) {
        return <Spinner />;
    }

    if (!userName) {
        return (
            <Flexbox css={sectionStyle}>
                <div id="login-kit-button" ref={loginButtonRef} />
            </Flexbox>
        );
    }

    return (
        <FlexSection flexDirection="row" alignItems="baseline" css={sectionStyle}>
            <StatusLabel status="success">Snapchat user: {userName}</StatusLabel>
            <Button
                css={buttonStyle}
                onClick={() => {
                    logout();
                    onLogout?.();
                }}
            >
                Logout
            </Button>
        </FlexSection>
    );
}
